import { createIcon } from "@chakra-ui/icons";

export const AdobexdLogo = createIcon({
	displayName: "AdobexdLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M4.042 0h12.916A3.539 3.539 0 0120.5 3.542v12.416a3.539 3.539 0 01-3.542 3.542H4.042A3.539 3.539 0 01.5 15.958V3.542A3.539 3.539 0 014.042 0z"
				fill="#470137"
			/>
			<path
				d="M11.017 5.124l-2.5 4.125 2.666 4.375a.143.143 0 01.017.1c-.008.034-.042.009-.092.017H9.2c-.133 0-.225-.008-.283-.092-.175-.35-.359-.691-.534-1.041a33.608 33.608 0 00-.566-1.05c-.2-.359-.4-.717-.6-1.084H7.2c-.175.359-.367.717-.558 1.075-.192.359-.384.717-.567 1.067-.192.35-.383.708-.575 1.05-.033.083-.1.092-.192.092H3.475c-.033 0-.058.016-.058-.025a.116.116 0 01.016-.092l2.592-4.25L3.5 5.116c-.025-.033-.033-.067-.017-.083.017-.025.05-.034.084-.034h1.891c.042 0 .084.009.117.017a.236.236 0 01.083.075c.159.358.342.717.534 1.075.2.358.391.708.6 1.058.2.35.383.7.558 1.059h.017c.175-.367.358-.725.541-1.075.184-.35.375-.7.567-1.05.192-.35.375-.709.558-1.05.009-.034.025-.067.05-.084a.159.159 0 01.109-.016h1.758a.077.077 0 01.091.058c.009.008-.008.042-.024.058zM14.866 13.917a4.144 4.144 0 01-1.791-.375 2.906 2.906 0 01-1.259-1.134c-.308-.508-.458-1.141-.458-1.9a3.423 3.423 0 011.783-3.05c.584-.325 1.284-.483 2.109-.483.041 0 .1 0 .175.008.075.009.158.009.258.017V4.367c0-.059.025-.092.083-.092h1.692c.042-.008.075.025.083.058v7.95c0 .15.009.317.017.5.017.175.025.342.033.484 0 .058-.025.108-.083.133a6.365 6.365 0 01-1.358.4 7.35 7.35 0 01-1.284.117zm.817-1.667V8.583c-.075-.016-.15-.033-.225-.041-.092-.009-.183-.017-.275-.017-.325 0-.65.067-.942.217-.283.141-.525.35-.708.616-.183.267-.275.625-.275 1.059-.008.291.042.583.142.858.083.225.208.425.375.592.158.15.35.266.566.333.225.075.459.108.692.108.125 0 .242-.008.35-.016a.73.73 0 00.3-.042z"
				fill="#FF61F6"
			/>
		</g>
	),
});

export const AtlassianLogo = createIcon({
	displayName: "AtlassianLogo",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				d="M6.427 9.239a.57.57 0 00-.798-.108.591.591 0 00-.167.209l-4.9 9.803a.586.586 0 00.524.847h6.827a.562.562 0 00.523-.324c1.474-3.043.58-7.67-2.01-10.427z"
				fill="#2684FF"
			/>
			<path
				d="M10.028.318a12.932 12.932 0 00-.755 12.765l3.292 6.583a.586.586 0 00.523.324h6.826a.583.583 0 00.586-.585c0-.091-.02-.18-.06-.262L11.024.315a.552.552 0 00-.997 0v.003z"
				fill="#2684FF"
			/>
		</g>
	),
});

export const CartIcon = createIcon({
	displayName: "CartIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M7.984 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM17.828 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM20.324 5.558a1.051 1.051 0 00-.815-.386H6.134l-.27-1.528a.703.703 0 00-.692-.581H2.359a.703.703 0 000 1.406h2.223L6.59 15.841a.703.703 0 00.692.581h11.25a.703.703 0 100-1.406H7.871l-.248-1.406h10.62a1.057 1.057 0 001.035-.848l1.266-6.328a1.055 1.055 0 00-.22-.876z"
		/>
	),
});

export const ClockIcon = createIcon({
	displayName: "ClockIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<g>
				<rect fill="none" height="24" width="24" />
			</g>
			<g>
				<g>
					<g>
						<path
							fill="currentColor"
							d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z"
						/>
					</g>
				</g>
			</g>
		</g>
	),
});
export const CreativeTimLogo = createIcon({
	displayName: "CreativeTimLogo",
	viewBox: "0 0 100 100",
	path: (
		<g
			xmlns="http://www.w3.org/2000/svg"
			width="50px"
			height="50px"
			version="1.1"
		>
			<g
				id="logo-creative-tim-black"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				<g
					id="icon"
					transform="translate(15.000000, 19.000000)"
					fill="currentColor"
					fillRule="nonzero"
				>
					<path
						d="M66.4346744,1.49018376e-13 L3.56968951,1.49018376e-13 C1.59820443,1.49018376e-13 -2.98036753e-13,1.59820443 -2.98036753e-13,3.56968951 L-2.98036753e-13,33.5035241 C-2.98036753e-13,35.4750091 1.59820443,37.0732136 3.56968951,37.0732136 L16.4677598,37.0732136 L16.4677598,66.4346744 C16.4666001,67.3810129 16.8417189,68.288989 17.5104719,68.9585615 C18.1792249,69.628134 19.0867408,70.0043639 20.03308,70.0043639 L49.9669146,70.0043639 C51.9383997,70.0043639 53.5366041,68.4061595 53.5366041,66.4346744 L53.5366041,37.0863214 L66.4346744,37.0863214 C67.3810136,37.0863221 68.2885296,36.7100915 68.9572826,36.0405189 C69.6260355,35.3709464 70.0011544,34.4629704 70,33.5166319 L70,3.56968951 C70.0011544,2.62335099 69.6260355,1.71537495 68.9572826,1.04580242 C68.2885296,0.37622988 67.3810136,1.49018376e-13 66.4346744,1.49018376e-13 Z M4.13769396,4.14206323 L32.9311503,4.14206323 L32.9311503,32.9355196 L4.13769396,32.9355196 L4.13769396,4.14206323 Z M49.3989102,65.86667 L20.6054538,65.86667 L20.6054538,37.0863214 L49.3989102,37.0863214 L49.3989102,65.86667 Z M65.8623007,32.9355196 L37.0688443,32.9355196 L37.0688443,4.14206323 L65.8623007,4.14206323 L65.8623007,32.9355196 Z"
						id="Shape"
					/>
					<path
						d="M23.6988934,23.3056595 C24.5142794,24.0708897 25.7898859,24.0506562 26.5805917,23.2599503 C27.3712976,22.4692445 27.3915311,21.193638 26.6263009,20.378252 L20.015603,13.767554 C19.2050095,12.9645312 17.8987889,12.9645312 17.0881954,13.767554 L10.4600204,20.378252 C9.90907005,20.8953125 9.68342943,21.6713831 9.87125954,22.4032422 C10.0590897,23.1351013 10.6305787,23.7065903 11.3624377,23.8944204 C12.0942968,24.0822505 12.8703675,23.8566099 13.387428,23.3056595 L18.5344222,18.1586654 L23.6988934,23.3056595 Z"
						id="Path"
					/>
					<path
						d="M46.3185783,23.3056595 L51.4655725,18.1586654 L56.6125667,23.3056595 C57.4279526,24.0708897 58.7035592,24.0506562 59.494265,23.2599503 C60.2849709,22.4692445 60.3052044,21.193638 59.5399742,20.378252 L52.9292763,13.767554 C52.1186828,12.9645312 50.8124622,12.9645312 50.0018687,13.767554 L43.3911708,20.378252 C42.6259406,21.193638 42.6461741,22.4692445 43.43688,23.2599503 C44.2275858,24.0506562 45.5031924,24.0708897 46.3185783,23.3056595 L46.3185783,23.3056595 Z"
						id="Path"
					/>
					<path
						d="M29.8508185,46.6987044 C29.0342976,45.9346441 27.7586832,45.9567597 26.9691385,46.7486649 C26.1795937,47.54057 26.1612859,48.8162446 26.9277802,49.6304812 L33.5384782,56.2368099 C33.9262423,56.6258256 34.452915,56.8444779 35.002182,56.8444779 C35.5514489,56.8444779 36.0781217,56.6258256 36.4658857,56.2368099 L43.0765837,49.6304812 C43.6002952,49.1075502 43.8052442,48.3449453 43.6142284,47.6299323 C43.4232126,46.9149194 42.8652519,46.3561259 42.1505246,46.1640439 C41.4357974,45.971962 40.6728876,46.1757734 40.1491761,46.6987044 L35.002182,51.8500678 L29.8508185,46.6987044 Z"
						id="Path"
					/>
				</g>
			</g>
		</g>
	),

	//   <chakra.svg
	//   height="50px"
	//   width="50px"
	//   viewBox="0 0 100 100"
	//   fill="none"
	//   xmlns="http://www.w3.org/2000/svg"
	//   color={fill}
	//   {...props}
	// >
	// </chakra.svg>
});

export const CreditIcon = createIcon({
	displayName: "CreditIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M1.406 17.023a2.461 2.461 0 002.461 2.46h14.766a2.461 2.461 0 002.46-2.46v-6.768H1.407v6.768zm2.9-3.34a1.318 1.318 0 011.319-1.318h2.11a1.318 1.318 0 011.318 1.318v.879a1.318 1.318 0 01-1.319 1.318H5.625a1.318 1.318 0 01-1.318-1.318v-.879zM18.633 4.014H3.867a2.46 2.46 0 00-2.46 2.461v1.143h19.687V6.475a2.46 2.46 0 00-2.461-2.46z"
		/>
	),
});

export const DashboardLogo = createIcon({
	displayName: "DashboardLogo",
	viewBox: "0 0 1000 257",
	path: (
		<g width="998" height="257" viewBox="0 0 998 257" fill="none">
			<g clipPath="url(#clip0)">
				<path
					d="M388.5 115.302C406.112 115.302 413.966 126.726 416.584 136.96L441.336 127.916C436.576 109.352 419.44 89.836 388.262 89.836C354.942 89.836 329 115.54 329 151.24C329 186.464 354.942 212.882 388.976 212.882C419.44 212.882 436.814 193.128 442.288 175.04L418.012 166.234C415.394 175.04 407.064 187.654 388.976 187.654C371.602 187.654 356.608 174.564 356.608 151.24C356.608 127.916 371.602 115.302 388.5 115.302Z"
					fill="currentColor"
				/>
				<path
					d="M484.894 141.244C485.37 126.488 493.7 115.064 508.932 115.064C526.306 115.064 532.732 126.488 532.732 140.768V209.312H560.34V136.008C560.34 110.542 546.536 90.074 517.976 90.074C505.838 90.074 492.748 94.358 484.894 104.592V37H457.286V209.312H484.894V141.244Z"
					fill="currentColor"
				/>
				<path
					d="M577.29 177.896C577.29 196.222 592.284 212.882 616.56 212.882C635.362 212.882 646.786 203.362 652.26 194.556C652.26 203.838 653.212 208.598 653.45 209.312H679.154C678.916 208.122 677.726 201.22 677.726 190.748V133.152C677.726 110.066 664.16 89.836 628.46 89.836C599.9 89.836 581.812 107.686 579.67 127.678L604.898 133.39C606.088 121.728 614.18 112.446 628.698 112.446C643.93 112.446 650.594 120.3 650.594 130.058C650.594 134.104 648.69 137.436 642.026 138.388L612.276 142.91C592.522 145.766 577.29 157.19 577.29 177.896ZM621.796 191.224C610.848 191.224 604.898 184.084 604.898 176.23C604.898 166.71 611.8 161.95 620.368 160.522L650.594 156V161.236C650.594 183.846 637.266 191.224 621.796 191.224Z"
					fill="currentColor"
				/>
				<path
					d="M810.108 93.406H773.456L728.95 140.292V37H701.58V209.312H728.95V176.944L743.23 161.95L777.264 209.312H811.06L762.508 142.434L810.108 93.406Z"
					fill="currentColor"
				/>
				<path
					d="M889.349 92.692C888.159 92.454 885.303 91.978 881.971 91.978C866.739 91.978 853.887 99.356 848.413 111.97V93.406H821.519V209.312H849.127V154.096C849.127 132.438 858.885 120.062 880.305 120.062C883.161 120.062 886.255 120.3 889.349 120.776V92.692Z"
					fill="currentColor"
				/>
				<path
					d="M895.968 177.896C895.968 196.222 910.962 212.882 935.238 212.882C954.04 212.882 965.464 203.362 970.938 194.556C970.938 203.838 971.89 208.598 972.128 209.312H997.832C997.594 208.122 996.404 201.22 996.404 190.748V133.152C996.404 110.066 982.838 89.836 947.138 89.836C918.578 89.836 900.49 107.686 898.348 127.678L923.576 133.39C924.766 121.728 932.858 112.446 947.376 112.446C962.608 112.446 969.272 120.3 969.272 130.058C969.272 134.104 967.368 137.436 960.704 138.388L930.954 142.91C911.2 145.766 895.968 157.19 895.968 177.896ZM940.474 191.224C929.526 191.224 923.576 184.084 923.576 176.23C923.576 166.71 930.478 161.95 939.046 160.522L969.272 156V161.236C969.272 183.846 955.944 191.224 940.474 191.224Z"
					fill="currentColor"
				/>
				<rect width="257" height="257" rx="128.5" fill="#4FD1C5" />
				<path
					d="M69.5584 133.985L157.15 46.9959C158.787 45.3708 161.42 47.3484 160.315 49.3729L127.714 109.125C126.987 110.457 127.951 112.083 129.47 112.083H185.809C187.624 112.083 188.501 114.306 187.174 115.545L88.4456 207.687C86.6753 209.339 84.0405 207.011 85.4617 205.051L132.197 140.578C133.156 139.256 132.211 137.404 130.578 137.404H70.9677C69.1826 137.404 68.2917 135.243 69.5584 133.985Z"
					fill="white"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear"
					x1="128.5"
					y1="0"
					x2="128.5"
					y2="257"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#7BCBD4" />
					<stop offset="1" stopColor="#29C6B7" />
				</linearGradient>
				<clipPath id="clip0">
					<rect width="997.832" height="257" fill="white" />
				</clipPath>
			</defs>
		</g>
	),
});

export const TriformDashboardLogo = createIcon({
	displayName: "TriformDashboardLogo",
	viewBox: "0 0 16 16",
	path: (
		<g>
			<path
				d="M1.5 15.5009C0.7203 15.5009 0.07955 14.9061 0.00687003 14.1454L0 14.0009V3.00092C0 2.22122 0.59489 1.58047 1.35554 1.50779L1.5 1.50092H6C6.7797 1.50092 7.4204 2.09581 7.4931 2.85646L7.5 3.00092V3.25535L9.6886 0.986096C10.2276 0.426906 11.0959 0.376596 11.6956 0.847976L11.8118 0.949216L14.5694 3.67387C15.1219 4.21976 15.1614 5.08861 14.68 5.68505L14.5767 5.80053L12.266 8.00035L12.5 8.00092C13.2797 8.00092 13.9204 8.59578 13.9931 9.35648L14 9.50088V14.0009C14 14.7806 13.4051 15.4214 12.6445 15.4941L12.5 15.5009H1.5ZM6.5 9.00088H1V14.0009C1 14.2157 1.13542 14.3989 1.32553 14.4697L1.41012 14.4929L1.5 14.5009H6.5V9.00088ZM12.5 9.00088H7.5V14.5009H12.5C12.7455 14.5009 12.9496 14.3241 12.9919 14.0908L13 14.0009V9.50088C13 9.25548 12.8231 9.05128 12.5899 9.00898L12.5 9.00088ZM7.5 6.21035V8.00035H9.29L7.5 6.21035ZM6 2.50092H1.5C1.25454 2.50092 1.05039 2.67779 1.00806 2.91104L1 3.00092V8.00092H6.5V3.00092C6.5 2.78614 6.36458 2.60299 6.17447 2.5322L6.08988 2.50898L6 2.50092ZM11.1222 1.67357C10.9396 1.49744 10.6692 1.48247 10.4768 1.62096L10.4086 1.68007L7.7926 4.39421C7.6271 4.56592 7.6086 4.82593 7.7356 5.01736L7.799 5.09475L10.4147 7.71047C10.5826 7.87838 10.8409 7.90227 11.0345 7.78022L11.1131 7.71898L13.8708 5.09231C14.0433 4.91771 14.061 4.64817 13.9248 4.45411L13.8665 4.38521L11.1222 1.67357Z"
				fill="#E0E0E0"
			/>
		</g>
	),
});

export const SandBoxIcon = createIcon({
	displayName: "SandBoxIcon",
	viewBox: "0 0 19 16",
	path: (
		<g>
			<path
				d="M12.8902 0H2.5415L2.41313 0.00432491C1.43747 0.0702999 0.666504 0.882617 0.666504 1.875V10.6269L0.670829 10.7552C0.736804 11.7309 1.54912 12.5019 2.5415 12.5019L6.08234 12.5017V14.5833L4.62484 14.5837L4.54003 14.5894C4.23496 14.6307 3.99984 14.8923 3.99984 15.2087C3.99984 15.5539 4.27966 15.8337 4.62484 15.8337H13.3748L13.4597 15.828C13.7647 15.7866 13.9998 15.5251 13.9998 15.2087C13.9998 14.8635 13.72 14.5837 13.3748 14.5837L11.9157 14.5833V12.5017L15.4572 12.5019L15.5856 12.4976C16.5613 12.4316 17.3322 11.6192 17.3322 10.6269V5.41708H16.0822V10.6269L16.0765 10.7117C16.0351 11.0167 15.7736 11.2519 15.4572 11.2519H2.5415L2.4567 11.2462C2.15163 11.2048 1.9165 10.9433 1.9165 10.6269V1.875L1.92221 1.79019C1.9636 1.48513 2.22509 1.25 2.5415 1.25H12.7497V0.625408C12.7497 0.401583 12.8001 0.189533 12.8902 0ZM7.3315 12.5017H10.6648L10.6657 14.5837H7.33234L7.3315 12.5017ZM13.583 0.625C13.583 0.279825 13.8628 0 14.208 0H17.5412C17.8863 0 18.1662 0.279825 18.1662 0.625V3.95833C18.1662 4.30351 17.8863 4.58333 17.5412 4.58333H14.208C13.8628 4.58333 13.583 4.30351 13.583 3.95833V3.33333H13.3138C13.1216 3.33333 12.951 3.45629 12.8903 3.63859L12.1287 5.92333C11.8978 6.61608 11.2494 7.08333 10.5193 7.08333H9.833V8.54167C9.833 8.88683 9.55317 9.16667 9.208 9.16667H5.87484C5.52966 9.16667 5.24984 8.88683 5.24984 8.54167V5.20833C5.24984 4.86316 5.52966 4.58333 5.87484 4.58333H9.208C9.55317 4.58333 9.833 4.86316 9.833 5.20833V5.83333H10.5193C10.7114 5.83333 10.882 5.71037 10.9428 5.52807L11.7043 3.2433C11.9353 2.55058 12.5836 2.08333 13.3138 2.08333H13.583V0.625ZM14.833 2.72327V3.33333H16.9162V1.25H14.833V2.6934C14.8331 2.69837 14.8332 2.70334 14.8332 2.70833C14.8332 2.71332 14.8331 2.7183 14.833 2.72327ZM6.49984 5.83333V7.91667H8.583V5.83333H6.49984Z"
				fill="#E0E0E0"
			/>
		</g>
	),
});
export const ConnectionsIcon = createIcon({
	displayName: "ConnectionsIcon",
	viewBox: "0 0 16 17",
	path: (
		<g>
			<path
				d="M15.8536 1.35355C16.0488 1.15829 16.0488 0.841713 15.8536 0.646453C15.6583 0.451182 15.3417 0.451182 15.1464 0.646453L12.4781 3.31475C10.8949 2.07957 8.6024 2.19014 7.14607 3.64646L6.84607 3.94646C6.26421 4.52832 6.26421 5.47171 6.84607 6.05357L10.4461 9.6536C11.0279 10.2354 11.9713 10.2354 12.5532 9.6536L12.8532 9.3536C14.3094 7.89737 14.42 5.60518 13.1852 4.02191L15.8536 1.35355ZM11.8461 8.9465C11.6547 9.1378 11.3445 9.1378 11.1532 8.9465L7.55318 5.34646C7.36184 5.15513 7.36184 4.84491 7.55318 4.65357L7.85318 4.35357C9.0386 3.16812 10.9606 3.16812 12.1461 4.35357C13.3315 5.53902 13.3315 7.46101 12.1461 8.6465L11.8461 8.9465ZM5.55393 7.34643C4.97207 6.76457 4.02869 6.76457 3.44682 7.34643L3.14683 7.64643C1.69063 9.1026 1.57995 11.3948 2.8148 12.9781L0.146453 15.6464C-0.0488175 15.8417 -0.0488175 16.1583 0.146453 16.3536C0.341713 16.5488 0.658292 16.5488 0.853552 16.3536L3.52186 13.6852C5.10515 14.9204 7.39761 14.8099 8.8539 13.3535L9.1539 13.0535C9.7358 12.4717 9.7358 11.5283 9.1539 10.9464L5.55393 7.34643ZM4.15393 8.05354C4.34527 7.8622 4.65549 7.8622 4.84682 8.05354L8.4468 11.6535C8.6382 11.8449 8.6382 12.1551 8.4468 12.3464L8.1468 12.6464C6.96137 13.8319 5.03938 13.8319 3.85393 12.6464C2.66848 11.461 2.66848 9.539 3.85393 8.35354L4.15393 8.05354Z"
				fill="#E0E0E0"
			/>
		</g>
	),
});
export const IndexesIcon = createIcon({
	displayName: "IndexesIcon",
	viewBox: "0 0 16 15",
	path: (
		<g>
			<path
				d="M0.5 2.70833C0.5 1.21256 1.71256 0 3.20833 0H12.7917C14.2874 0 15.5 1.21256 15.5 2.70833V12.2917C15.5 13.7874 14.2874 15 12.7917 15H3.20833C1.71256 15 0.5 13.7874 0.5 12.2917V2.70833ZM3.20833 1.25C2.40292 1.25 1.75 1.90292 1.75 2.70833V12.2917C1.75 13.0971 2.40292 13.75 3.20833 13.75H5.08333V1.25H3.20833ZM9.66667 13.75V10.4167H6.33333V13.75H9.66667ZM10.9167 13.75H12.7917C13.5971 13.75 14.25 13.0971 14.25 12.2917V10.4167H10.9167V13.75ZM10.9167 9.16667H14.25V5.83333H10.9167V9.16667ZM9.66667 5.83333H6.33333V9.16667H9.66667V5.83333ZM9.66667 4.58333V1.25H6.33333V4.58333H9.66667ZM10.9167 4.58333H14.25V2.70833C14.25 1.90292 13.5971 1.25 12.7917 1.25H10.9167V4.58333Z"
				fill="#E0E0E0"
			/>
		</g>
	),
});
export const APISIcon = createIcon({
	displayName: "APIs Icon",
	viewBox: "0 0 15 15",
	path: (
		<g>
			<path
				d="M2.5 0.5C1.67157 0.5 1 1.17157 1 2V4C1 4.82843 1.67157 5.5 2.5 5.5H3V9.3407C2.92593 9.3835 2.85618 9.4366 2.79282 9.4999L0.999921 11.2928C0.609401 11.6833 0.609401 12.3165 0.999921 12.707L2.79282 14.4999C3.18334 14.8904 3.81651 14.8904 4.20703 14.4999L5.99993 12.707C6.06325 12.6437 6.1163 12.574 6.15909 12.5H10V13C10 13.8284 10.6716 14.5 11.5 14.5H13.5C14.3284 14.5 15 13.8284 15 13V11C15 10.1716 14.3284 9.5 13.5 9.5H11.5C10.6716 9.5 10 10.1716 10 11V11.5H6.15917C6.11637 11.4259 6.06329 11.3562 5.99992 11.2928L4.20703 9.4999C4.14371 9.4366 4.07401 9.3835 4 9.3408V5.5H4.5C5.32843 5.5 6 4.82843 6 4V2C6 1.17157 5.32843 0.5 4.5 0.5H2.5ZM2 2C2 1.72386 2.22386 1.5 2.5 1.5H4.5C4.77614 1.5 5 1.72386 5 2V4C5 4.27614 4.77614 4.5 4.5 4.5H2.5C2.22386 4.5 2 4.27614 2 4V2ZM1.70703 11.9999L3.49992 10.207L5.29282 11.9999L3.49992 13.7928L1.70703 11.9999ZM11.5 10.5H13.5C13.7761 10.5 14 10.7239 14 11V13C14 13.2761 13.7761 13.5 13.5 13.5H11.5C11.2239 13.5 11 13.2761 11 13V11C11 10.7239 11.2239 10.5 11.5 10.5Z"
				fill="#E0E0E0"
			/>
		</g>
	),
});
export const BillingIcon = createIcon({
	displayName: "APIs Icon",
	viewBox: "0 0 20 21",
	path: (
		<g>
			<path
				d="M13.2141 12.2148C12.8591 12.2148 12.5713 12.5026 12.5713 12.8577C12.5713 13.2127 12.8591 13.5006 13.2141 13.5006H15.357C15.7121 13.5006 15.9999 13.2127 15.9999 12.8577C15.9999 12.5026 15.7121 12.2148 15.357 12.2148H13.2141Z"
				fill="#E0E0E0"
			/>
			<path
				d="M3.393 4.07227C2.30815 4.07227 1.42871 4.95171 1.42871 6.03655V14.2508C1.42871 15.3357 2.30815 16.2151 3.393 16.2151H16.6073C17.6921 16.2151 18.5716 15.3357 18.5716 14.2508V6.03655C18.5716 4.95171 17.6921 4.07227 16.6073 4.07227H3.393ZM2.50014 14.2508V8.71512H17.5001V14.2508C17.5001 14.744 17.1004 15.1437 16.6073 15.1437H3.393C2.89988 15.1437 2.50014 14.744 2.50014 14.2508ZM2.50014 7.64369V6.03655C2.50014 5.54344 2.89988 5.14369 3.393 5.14369H16.6073C17.1004 5.14369 17.5001 5.54344 17.5001 6.03655V7.64369H2.50014Z"
				fill="#E0E0E0"
			/>
		</g>
	),
});
export const FacebookIcon = createIcon({
	displayName: "Facebook Icon",
	viewBox: "0 0 15 16",
	path: (
		<g>
			<path
				d="M10.335 15.5V9.695H12.2792L12.57 7.43833H10.335V5.99833C10.335 5.345 10.5167 4.89917 11.4533 4.89917H12.6483V2.88083C12.0698 2.81945 11.4884 2.78969 10.9067 2.79167C9.18417 2.79167 8.005 3.84333 8.005 5.775V7.43833H6.05667V9.695H8.005V15.5H0.833333C0.61232 15.5 0.400358 15.4122 0.244078 15.2559C0.0877973 15.0996 0 14.8877 0 14.6667V1.33333C0 1.11232 0.0877973 0.900358 0.244078 0.744078C0.400358 0.587797 0.61232 0.5 0.833333 0.5H14.1667C14.3877 0.5 14.5996 0.587797 14.7559 0.744078C14.9122 0.900358 15 1.11232 15 1.33333V14.6667C15 14.8877 14.9122 15.0996 14.7559 15.2559C14.5996 15.4122 14.3877 15.5 14.1667 15.5H10.335Z"
				fill="#4267B2"
			/>
		</g>
	),
});
export const UploadIcon = createIcon({
	displayName: "Upload Icon",
	viewBox: "0 0 10 15",
	path: (
		<g>
			<path
				d="M0.5 1.83008H9.49847C9.7746 1.83008 9.99847 1.60622 9.99847 1.33008C9.99847 1.07694 9.81033 0.867751 9.56627 0.834638L9.49847 0.830078H0.5C0.22386 0.830078 0 1.05393 0 1.33008C0 1.5832 0.1881 1.7924 0.432153 1.82551L0.5 1.83008ZM4.92227 14.1619L5 14.1663C5.34187 14.1663 5.62367 13.909 5.6622 13.5774L5.66667 13.4997V5.10635L7.86273 7.30153C8.10307 7.5418 8.4812 7.56027 8.74273 7.35686L8.80553 7.30147C9.0458 7.06106 9.06427 6.68293 8.86087 6.4214L8.8054 6.3586L5.47367 3.02754C5.23347 2.78738 4.85553 2.7688 4.594 2.97188L4.5312 3.02727L1.19559 6.35833C0.93506 6.61853 0.934767 7.0406 1.19494 7.30113C1.4351 7.54167 1.81324 7.5604 2.07491 7.3572L2.13775 7.3018L4.33333 5.10968V13.4997C4.33333 13.8416 4.59067 14.1233 4.92227 14.1619Z"
				fill="#D0D0D0"
			/>
		</g>
	),
});
export const DeleteIcon = createIcon({
	displayName: "Delete Icon",
	viewBox: "0 0 14 15",
	path: (
		<g>
			<path
				d="M6.99967 0.666016C8.15501 0.666016 9.09914 1.57032 9.16294 2.70974L9.16634 2.83268H12.6663C12.9425 2.83268 13.1663 3.05654 13.1663 3.33268C13.1663 3.58582 12.9782 3.79501 12.7342 3.82812L12.6663 3.83268H12.1357L11.2823 12.5121C11.1938 13.4115 10.4653 14.106 9.57474 14.1623L9.45774 14.166H4.54163C3.6379 14.166 2.87544 13.509 2.73223 12.6283L2.7171 12.5121L1.86301 3.83268H1.33301C1.07987 3.83268 0.870681 3.64458 0.837574 3.40053L0.833008 3.33268C0.833008 3.07955 1.02111 2.87036 1.26516 2.83725L1.33301 2.83268H4.83301C4.83301 1.63606 5.80307 0.666016 6.99967 0.666016ZM11.131 3.83268H2.86767L3.71229 12.4143C3.75146 12.8124 4.06656 13.1222 4.45691 13.1617L4.54163 13.166H9.45774C9.85781 13.166 10.1969 12.8827 10.2745 12.4981L10.2871 12.4143L11.131 3.83268ZM8.16634 5.66602C8.41947 5.66602 8.62867 5.85412 8.66181 6.09817L8.66634 6.16602V10.8327C8.66634 11.1088 8.44247 11.3327 8.16634 11.3327C7.91321 11.3327 7.70401 11.1446 7.67087 10.9005L7.66634 10.8327V6.16602C7.66634 5.88988 7.89021 5.66602 8.16634 5.66602ZM5.83301 5.66602C6.08614 5.66602 6.29534 5.85412 6.32847 6.09817L6.33301 6.16602V10.8327C6.33301 11.1088 6.10914 11.3327 5.83301 11.3327C5.57987 11.3327 5.37068 11.1446 5.33757 10.9005L5.33301 10.8327V6.16602C5.33301 5.88988 5.55687 5.66602 5.83301 5.66602ZM6.99967 1.66602C6.38754 1.66602 5.88554 2.13742 5.83687 2.737L5.83301 2.83268H8.16634C8.16634 2.18835 7.64401 1.66602 6.99967 1.66602Z"
				fill="#D0D0D0"
			/>
		</g>
	),
});
export const GoogleIcon = createIcon({
	displayName: "Google Icon",
	viewBox: "0 0 15 16",
	path: (
		<>
			<g clip-path="url(#clip0_8865_79934)">
				<path
					d="M14.9926 8.14945C14.9926 7.49394 14.9416 7.01559 14.8311 6.51953H7.6499V9.47819H11.8651C11.7802 10.2135 11.3212 11.3208 10.3014 12.0648L10.2871 12.1639L12.5577 13.9973L12.715 14.0137C14.1597 12.6229 14.9926 10.5766 14.9926 8.14945Z"
					fill="#71C9EC"
				/>
				<path
					d="M7.64946 15.9446C9.71457 15.9446 11.4482 15.2359 12.7146 14.0135L10.301 12.0646C9.6551 12.5341 8.78824 12.8618 7.64946 12.8618C5.62683 12.8618 3.91015 11.4711 3.2982 9.54883L3.2085 9.55677L0.847526 11.4613L0.81665 11.5508C2.07442 14.1551 4.65797 15.9446 7.64946 15.9446Z"
					fill="#34A853"
				/>
				<path
					d="M3.29786 9.54985C3.13639 9.05379 3.04295 8.52225 3.04295 7.97306C3.04295 7.4238 3.1364 6.89232 3.28937 6.39626L3.28509 6.29061L0.894537 4.35547L0.816322 4.39425C0.297938 5.47498 0.000488281 6.6886 0.000488281 7.97306C0.000488281 9.25751 0.297938 10.4711 0.816322 11.5518L3.29786 9.54985Z"
					fill="#FBBC05"
				/>
				<path
					d="M7.64944 3.08269C9.08566 3.08269 10.0545 3.72934 10.6069 4.26974L12.7655 2.07286C11.4398 0.788397 9.71454 0 7.64944 0C4.65795 0 2.07441 1.78937 0.81665 4.39371L3.2897 6.39573C3.91014 4.47347 5.62682 3.08269 7.64944 3.08269Z"
					fill="#EB4335"
				/>
			</g>
			<defs>
				<clipPath id="clip0_8865_79934">
					<rect width="15" height="16" fill="white" />
				</clipPath>
			</defs>
		</>
	),
});

export const SupportIcon = createIcon({
	// Doesn't display the full icon without w and h being specified
	displayName: "SupportIcon",
	viewBox: "0 0 20 21",
	path: (
		<g>
			<path
				d="M6.78654 5.75542C7.14824 5.56218 7.53747 5.50003 7.91642 5.5C8.35512 5.49998 8.86462 5.64408 9.27612 5.9813C9.70696 6.33432 9.99979 6.87594 9.99979 7.58272C9.99979 8.39488 9.42587 8.83581 9.10229 9.08439C9.07712 9.10372 9.05354 9.12189 9.03179 9.13898C8.67796 9.41706 8.54146 9.56564 8.54146 9.87439C8.54146 10.2196 8.26163 10.4994 7.91646 10.4994C7.57128 10.4994 7.29146 10.2196 7.29146 9.87439C7.29146 8.92939 7.88417 8.45102 8.25946 8.15611C8.68721 7.81997 8.74979 7.74509 8.74979 7.58272C8.74979 7.25186 8.62596 7.0646 8.48387 6.94817C8.32249 6.81593 8.10281 6.74999 7.91649 6.75C7.67045 6.75002 7.50134 6.79074 7.37554 6.85795C7.256 6.92181 7.12952 7.03394 7.00757 7.25887C6.84305 7.56232 6.46368 7.67494 6.16024 7.51043C5.85679 7.34591 5.74417 6.96654 5.90868 6.66309C6.1284 6.25782 6.41858 5.95198 6.78654 5.75542Z"
				fill="#E0E0E0"
			/>
			<path
				d="M7.91689 13.0007C8.37716 13.0007 8.75025 12.6277 8.75025 12.1674C8.75025 11.7071 8.37716 11.334 7.91689 11.334C7.45662 11.334 7.0835 11.7071 7.0835 12.1674C7.0835 12.6277 7.45662 13.0007 7.91689 13.0007Z"
				fill="#E0E0E0"
			/>
			<path
				d="M7.91654 3C4.46477 3 1.66654 5.79822 1.66654 9.25C1.66654 10.1941 1.87627 11.0907 2.25209 11.8945C2.04039 12.7262 1.80389 13.6535 1.64856 14.2623C1.45437 15.0233 2.13973 15.7157 2.90168 15.5325C3.52687 15.3822 4.48772 15.1516 5.34395 14.9475C6.12921 15.3026 7.00058 15.5 7.91654 15.5C11.3683 15.5 14.1666 12.7018 14.1666 9.25C14.1666 5.79822 11.3683 3 7.91654 3ZM2.91655 9.25C2.91655 6.48858 5.15512 4.25 7.91654 4.25C10.678 4.25 12.9166 6.48858 12.9166 9.25C12.9166 12.0114 10.678 14.25 7.91654 14.25C7.11594 14.25 6.36096 14.0623 5.69158 13.7291L5.48873 13.6281L5.2683 13.6806C4.49936 13.8636 3.61097 14.0766 2.94517 14.2365C3.1108 13.5873 3.3301 12.727 3.52024 11.9797L3.57873 11.7498L3.46996 11.539C3.11645 10.8538 2.91655 10.0762 2.91655 9.25Z"
				fill="#E0E0E0"
			/>
			<path
				d="M12.0833 17.9998C10.4421 17.9998 8.94867 17.3672 7.8335 16.3326C7.86116 16.3329 7.88886 16.3331 7.9166 16.3331C8.51492 16.3331 9.09584 16.2589 9.65084 16.1192C10.3708 16.5209 11.2003 16.7498 12.0833 16.7498C12.8838 16.7498 13.6388 16.562 14.3082 16.2288L14.5111 16.1278L14.7315 16.1803C15.4994 16.3631 16.3691 16.5518 17.0141 16.6882C16.8683 16.0628 16.6694 15.2256 16.4795 14.4794L16.4211 14.2496L16.5298 14.0388C16.8833 13.3536 17.0833 12.5759 17.0833 11.7498C17.0833 9.98745 16.1716 8.43817 14.7941 7.54771C14.6454 6.94499 14.4197 6.37266 14.1278 5.8418C16.5755 6.68873 18.3333 9.01395 18.3333 11.7498C18.3333 12.694 18.1234 13.5909 17.7474 14.3948C17.9583 15.2348 18.1718 16.1447 18.3073 16.7308C18.4776 17.4683 17.8281 18.1358 17.0843 17.9804C16.4784 17.8537 15.5263 17.6505 14.6565 17.4469C13.8711 17.8022 12.9995 17.9998 12.0833 17.9998Z"
				fill="#E0E0E0"
			/>
		</g>
	),
});

export const DocumentIcon = createIcon({
	displayName: "DocumentIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M18.809 10.344h-6.153a2.11 2.11 0 01-2.11-2.11V2.083a.176.176 0 00-.175-.176H6.328A2.812 2.812 0 003.516 4.72v14.063a2.812 2.812 0 002.812 2.812h9.844a2.812 2.812 0 002.812-2.813V10.52a.176.176 0 00-.175-.176z"
			/>
			<path
				fill="currentColor"
				d="M18.423 8.789l-6.32-6.32a.088.088 0 00-.15.062v5.705a.703.703 0 00.703.703h5.705a.088.088 0 00.062-.15z"
			/>
		</g>
	),
});

export const GlobeIcon = createIcon({
	displayName: "GlobeIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M11.25 2.109a9.14 9.14 0 100 18.281 9.14 9.14 0 000-18.281z"
				strokeWidth=".75"
				strokeMiterlimit="10"
			/>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M11.25 2.109C8.698 2.109 6.3 6.2 6.3 11.249c0 5.048 2.4 9.14 4.951 9.14 2.552 0 4.951-4.092 4.951-9.14 0-5.048-2.399-9.14-4.95-9.14z"
				strokeWidth=".75"
				strokeMiterlimit="10"
			/>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904"
			/>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904M17.344 17.344c-1.68-1.193-3.796-1.904-6.094-1.904-2.298 0-4.413.711-6.094 1.904"
				strokeWidth=".75"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				stroke="currentColor"
				fill="transparent"
				d="M11.25 2.109v18.28M20.39 11.249H2.11"
				strokeWidth=".75"
				strokeMiterlimit="10"
			/>
		</g>
	),
});

export const HelpIcon = createIcon({
	displayName: "HelpIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M11.25 0C5.04 0 0 5.04 0 11.25S5.04 22.5 11.25 22.5 22.5 17.46 22.5 11.25 17.46 0 11.25 0zm-.352 17.813a1.172 1.172 0 110-2.344 1.172 1.172 0 010 2.344zm1.96-5.977c-.95.637-1.08 1.222-1.08 1.758a.82.82 0 11-1.641 0c0-1.284.59-2.305 1.806-3.121 1.13-.758 1.768-1.239 1.768-2.295 0-.718-.41-1.264-1.26-1.668-.199-.095-.644-.187-1.191-.18-.687.008-1.22.172-1.63.503-.775.623-.84 1.302-.84 1.312a.821.821 0 11-1.642-.08c.007-.142.106-1.425 1.452-2.507.698-.562 1.585-.854 2.636-.866.745-.01 1.444.117 1.918.34 1.418.672 2.198 1.79 2.198 3.146 0 1.982-1.325 2.872-2.494 3.658z"
		/>
	),
});

export const HomeIcon = createIcon({
	displayName: "HomeIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M11.494 4.951a.351.351 0 00-.486 0l-8.09 7.729a.352.352 0 00-.109.254v7.254a1.406 1.406 0 001.405 1.406h4.223a.703.703 0 00.704-.703v-5.976a.351.351 0 01.351-.352h3.516a.351.351 0 01.351.352v5.976a.703.703 0 00.704.703h4.22a1.407 1.407 0 001.407-1.406v-7.254a.35.35 0 00-.108-.254L11.494 4.95z"
			/>
			<path
				fill="currentColor"
				d="M21.574 11.23l-3.287-3.144V3.314a.703.703 0 00-.703-.703h-2.11a.703.703 0 00-.703.703V4.72l-2.545-2.434c-.239-.24-.593-.378-.976-.378-.38 0-.734.138-.972.379L.93 11.23a.717.717 0 00-.058.983.703.703 0 001.018.046l9.119-8.713a.352.352 0 01.486 0l9.12 8.713a.703.703 0 00.992-.019c.27-.28.248-.74-.033-1.01z"
			/>
		</g>
	),
});

export const InvisionLogo = createIcon({
	displayName: "InvisionLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M18.687 0H2.313A1.813 1.813 0 00.5 1.811v16.374C.5 19.188 1.312 20 2.313 20h16.374a1.813 1.813 0 001.813-1.813V1.812A1.813 1.813 0 0018.687 0z"
				fill="#DC395F"
			/>
			<path
				d="M7.184 6.293c.665 0 1.222-.522 1.222-1.204 0-.683-.557-1.204-1.222-1.204-.665 0-1.222.521-1.222 1.204 0 .682.557 1.204 1.222 1.204zM4.65 12.739a4.134 4.134 0 00-.108.905c0 1.06.575 1.764 1.797 1.764 1.013 0 1.834-.602 2.426-1.573l-.361 1.449h2.012l1.15-4.612c.287-1.168.844-1.774 1.689-1.774.665 0 1.078.413 1.078 1.096 0 .197-.018.413-.09.646l-.593 2.12c-.09.306-.126.611-.126.899 0 1.006.593 1.742 1.833 1.742 1.06 0 1.904-.682 2.371-2.317l-.79-.305c-.395 1.095-.737 1.293-1.006 1.293-.27 0-.414-.18-.414-.538 0-.162.037-.342.09-.558l.575-2.065c.144-.485.198-.915.198-1.31 0-1.546-.934-2.352-2.066-2.352-1.06 0-2.138.956-2.677 1.962l.395-1.806H8.962L8.53 8.996h1.438l-.885 3.544c-.695 1.545-1.972 1.57-2.132 1.534-.264-.06-.432-.159-.432-.5 0-.198.036-.482.126-.823l1.348-5.346H4.579l-.431 1.591h1.419L4.65 12.74"
				fill="#fff"
			/>
		</g>
	),
});

export const JiraLogo = createIcon({
	displayName: "JiraLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M20.26 10.42l-8.863-8.93-.86-.865-6.67 6.722L.814 10.42a.827.827 0 000 1.162l6.096 6.14 3.627 3.654 6.67-6.722.105-.104 2.947-2.964a.824.824 0 000-1.166zm-9.722 3.649L7.493 11l3.045-3.068L13.582 11l-3.044 3.068z"
				fill="#2684FF"
			/>
			<path
				d="M10.537 7.932a5.184 5.184 0 01-1.502-3.637A5.185 5.185 0 0110.515.65L3.852 7.36l3.626 3.654 3.06-3.082z"
				fill="url(#paint0_linear)"
			/>
			<path
				d="M13.59 10.992l-3.053 3.076a5.186 5.186 0 011.502 3.653c0 1.37-.54 2.683-1.502 3.652l6.682-6.728-3.63-3.653z"
				fill="url(#paint1_linear)"
			/>
		</g>
	),
});

export const MastercardIcon = createIcon({
	displayName: "MastercardIcon",
	viewBox: "0 0 24 24",
	path: (
		<svg
			width="24"
			height="20"
			viewBox="0 0 21 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="6.63158" cy="7.49999" r="6.63158" fill="#EB001B" />
			<circle cx="14.3686" cy="7.49999" r="6.63158" fill="#F79E1B" />
		</svg>
	),
});

export const PayPalIcon = createIcon({
	displayName: "PayPalIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M16.179 2.532C15.142 1.357 13.265.854 10.863.854H3.895a.997.997 0 00-.986.834L.007 19.945a.595.595 0 00.591.686H4.9l1.08-6.8-.033.215a.993.993 0 01.983-.834h2.044c4.017 0 7.16-1.619 8.08-6.3.027-.14.07-.406.07-.406.262-1.732-.001-2.907-.945-3.974z"
			/>
			<path
				fill="currentColor"
				d="M18.213 7.393c-.998 4.61-4.184 7.048-9.24 7.048H7.142L5.773 23.1h2.973a.87.87 0 00.862-.731l.035-.184.684-4.297.044-.237a.87.87 0 01.86-.731h.544c3.514 0 6.264-1.416 7.068-5.51.322-1.644.166-3.021-.63-4.017z"
			/>
		</g>
	),
});

export const PersonIcon = createIcon({
	displayName: "PersonIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M14.618 3.338c-.855-.924-2.05-1.432-3.368-1.432-1.325 0-2.524.505-3.375 1.423-.86.928-1.28 2.188-1.181 3.55.195 2.686 2.239 4.87 4.556 4.87s4.358-2.184 4.556-4.87c.1-1.349-.322-2.607-1.188-3.541zM18.984 21.592H3.515a1.363 1.363 0 01-1.063-.489 1.552 1.552 0 01-.316-1.279c.371-2.058 1.529-3.786 3.348-5 1.616-1.076 3.664-1.67 5.766-1.67s4.15.594 5.765 1.67c1.82 1.214 2.977 2.942 3.348 5 .085.471-.03.937-.315 1.279a1.362 1.362 0 01-1.064.49z"
		/>
	),
});

export const ProfileIcon = createIcon({
	displayName: "ProfileIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path d="M0 0h24v24H0V0z" fill="transparent" />
			<path
				fill="currentColor"
				d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
			/>
		</g>
	),
});

export const RocketIcon = createIcon({
	displayName: "RocketIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M20.99 2.182a.209.209 0 00-.156-.16c-2.574-.63-8.521 1.613-11.743 4.833a13.93 13.93 0 00-1.566 1.85c-.994-.087-1.987-.014-2.834.355-2.39 1.052-3.085 3.796-3.279 4.976a.424.424 0 00.464.492l3.837-.423c.002.29.02.578.052.866.02.2.108.386.25.527l1.486 1.482a.86.86 0 00.528.25c.286.033.573.05.86.053l-.42 3.832a.424.424 0 00.492.464c1.178-.19 3.927-.885 4.972-3.274.37-.847.445-1.836.36-2.824a13.96 13.96 0 001.855-1.567c3.232-3.216 5.462-9.03 4.842-11.732zm-8.067 7.896a2.11 2.11 0 112.983-2.984 2.11 2.11 0 01-2.983 2.984z"
			/>
			<path
				fill="currentColor"
				d="M7.4 18.054c-.24.241-.627.335-1.092.416-1.044.178-1.967-.725-1.779-1.78.072-.401.283-.962.415-1.094a.192.192 0 00-.16-.328 2.636 2.636 0 00-1.544.753c-1.033 1.034-1.13 4.87-1.13 4.87s3.838-.097 4.872-1.13c.417-.417.682-.961.752-1.546.017-.184-.207-.293-.334-.16z"
			/>
		</g>
	),
});

export const SettingsIcon = createIcon({
	displayName: "SettingsIcon",
	viewBox: "0 0 24 24",
	// path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
	path: (
		<g>
			<path d="M0,0h24v24H0V0z" fill="none" />
			<path
				fill="currentColor"
				d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
			/>
		</g>
	),
});

export const SlackLogo = createIcon({
	displayName: "SlackLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)" fillRule="evenodd" clipRule="evenodd">
			<path
				d="M7.832.5c-1.105 0-2 .919-1.999 2.05 0 1.13.895 2.048 2 2.05h2V2.55c.001-1.13-.894-2.048-2-2.05zm0 5.467H2.5c-1.106 0-2.001.918-2 2.05-.002 1.13.894 2.048 2 2.05h5.332c1.106-.001 2.002-.919 2-2.05.002-1.132-.894-2.05-2-2.05z"
				fill="#36C5F0"
			/>
			<path
				d="M20.5 8.016c0-1.13-.895-2.048-2-2.05-1.106.002-2.002.92-2 2.05v2.05h2c1.105 0 2-.918 2-2.05zm-5.334 0V2.55c.001-1.13-.893-2.048-2-2.05-1.105 0-2 .919-2 2.05v5.466c-.001 1.131.894 2.049 2 2.05 1.106 0 2.001-.918 2-2.05z"
				fill="#2EB67D"
			/>
			<path
				d="M13.166 21c1.106 0 2.001-.919 2-2.05.001-1.13-.894-2.048-2-2.05h-2v2.05c-.001 1.13.894 2.048 2 2.05zm0-5.467h5.333c1.106-.001 2.002-.92 2-2.05.002-1.131-.893-2.049-1.999-2.05h-5.333c-1.106 0-2.001.918-2 2.05-.001 1.13.893 2.049 1.999 2.05z"
				fill="#ECB22E"
			/>
			<path
				d="M.5 13.483c-.001 1.13.895 2.049 2 2.05 1.106-.001 2.001-.92 2-2.05v-2.05h-2c-1.105.001-2.001.919-2 2.05zm5.333 0v5.467c-.001 1.13.894 2.048 2 2.05 1.105 0 2-.919 2-2.05v-5.465c.002-1.131-.894-2.05-2-2.05-1.106 0-2 .917-2 2.048z"
				fill="#E01E5A"
			/>
		</g>
	),
});

export const SpotifyLogo = createIcon({
	displayName: "SpotifyLogo",
	viewBox: "0 0 24 24",
	path: (
		<g clipPath="url(#clip0)">
			<path
				d="M10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10c0-5.522-4.477-10-10-10zm4.586 14.422a.623.623 0 01-.857.208c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.216c3.808-.87 7.076-.495 9.712 1.115.294.181.387.564.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.786-2.13-9.965-1.166a.78.78 0 01-.973-.519.781.781 0 01.52-.972c3.632-1.102 8.147-.569 11.233 1.329a.78.78 0 01.258 1.072zm.106-2.835C13.19 6.95 7.875 6.775 4.797 7.708a.935.935 0 11-.543-1.79c3.533-1.072 9.404-.865 13.115 1.338a.935.935 0 01-.954 1.609z"
				fill="#2EBD59"
			/>
		</g>
	),
});

export const StatsIcon = createIcon({
	displayName: "StatsIcon",
	viewBox: "0 0 24 24",
	path: (
		<path
			fill="currentColor"
			d="M4.57 22.297H3.164a1.055 1.055 0 01-1.055-1.054v-6.328a1.055 1.055 0 011.055-1.055H4.57a1.055 1.055 0 011.055 1.055v6.328a1.055 1.055 0 01-1.055 1.054zM14.414 22.296h-1.406a1.055 1.055 0 01-1.055-1.055V10.695a1.055 1.055 0 011.055-1.055h1.406a1.055 1.055 0 011.055 1.055V21.24a1.055 1.055 0 01-1.055 1.055zM19.336 22.297H17.93a1.055 1.055 0 01-1.055-1.055V5.773A1.055 1.055 0 0117.93 4.72h1.406a1.055 1.055 0 011.055 1.054v15.47a1.055 1.055 0 01-1.055 1.054zM9.492 22.297H8.086a1.055 1.055 0 01-1.055-1.055V2.257a1.055 1.055 0 011.055-1.054h1.406a1.055 1.055 0 011.055 1.054v18.985a1.055 1.055 0 01-1.055 1.055z"
		/>
	),
});

export const WalletIcon = createIcon({
	displayName: "WalletIcon",
	viewBox: "0 0 24 24",
	path: (
		<g>
			<path
				fill="currentColor"
				d="M4.447 4.818h14.062c.164 0 .328.01.491.031a2.9 2.9 0 00-3.406-2.441L4.03 4.382h-.013a2.9 2.9 0 00-1.805 1.149 3.848 3.848 0 012.236-.713zM18.51 5.875H4.446a2.816 2.816 0 00-2.813 2.812v8.438a2.816 2.816 0 002.813 2.812h14.062a2.815 2.815 0 002.813-2.812V8.687a2.815 2.815 0 00-2.813-2.812zm-2.088 8.437a1.406 1.406 0 110-2.811 1.406 1.406 0 010 2.811z"
			/>
			<path
				fill="currentColor"
				d="M1.656 11.651V7.28c0-.952.528-2.549 2.358-2.895 1.553-.291 3.091-.291 3.091-.291s1.011.703.176.703-.813 1.077 0 1.077 0 1.032 0 1.032L4.007 10.62l-2.35 1.032z"
			/>
		</g>
	),
});

export const VisaIcon = createIcon({
	displayName: "VisaIcon",
	viewBox: "0 0 24 24",
	path: (
		<svg
			width="26"
			height="20"
			viewBox="0 0 30 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.6708 2.96349C12.6568 4.15055 13.653 4.81298 14.4034 5.20684C15.1744 5.61099 15.4333 5.87013 15.4304 6.23147C15.4245 6.78459 14.8153 7.02862 14.2452 7.03812C13.2505 7.05475 12.6723 6.74889 12.2125 6.51753L11.8542 8.32341C12.3155 8.55247 13.1696 8.75217 14.0554 8.76087C16.1345 8.76087 17.4947 7.65543 17.5021 5.94145C17.5102 3.76625 14.7087 3.64579 14.7278 2.67348C14.7344 2.37871 14.9956 2.06408 15.568 1.98406C15.8512 1.94368 16.6332 1.91274 17.5198 2.35252L17.8677 0.605286C17.391 0.418253 16.7782 0.239136 16.0153 0.239136C14.0583 0.239136 12.6819 1.35962 12.6708 2.96349ZM21.2115 0.389687C20.8319 0.389687 20.5118 0.628245 20.3691 0.99433L17.3991 8.63249H19.4767L19.8901 7.40183H22.429L22.6689 8.63249H24.5L22.9021 0.389687H21.2115ZM21.5021 2.61641L22.1016 5.7116H20.4596L21.5021 2.61641ZM10.1518 0.389687L8.51418 8.63249H10.4939L12.1308 0.389687H10.1518ZM7.22303 0.389687L5.16233 6.00003L4.32878 1.22966C4.23097 0.697187 3.84472 0.389687 3.41579 0.389687H0.0471011L0 0.629037C0.691574 0.790671 1.47729 1.0514 1.95326 1.33033C2.24457 1.50067 2.32775 1.64964 2.42336 2.05458L4.00214 8.63249H6.0945L9.3021 0.389687H7.22303Z"
				fill="#4318FF"
			/>
		</svg>
	),
});
